import { ROLE_PERMISSION_CODES } from './permissionCatalog';

export const CMS_PERMISSIONS = Object.freeze(Array.from(new Set([
  // Dashboard
  'dashboard_view',

  // Products / categories
  'products_view',
  'products_create',
  'products_edit',
  'products_delete',

  // Growers / customers / agreements
  'customers_view',
  'customers_create',
  'customers_edit',
  'customers_delete',
  'agreements_view',
  'agreements_create',
  'agreements_edit',



  
  // Inventory
  'inventory_view',
  'inventory_create',
  'inventory_edit',
  'inventory_adjust',

  // Warehouse / storage / bins / chambers / crates
  'warehouse_view',
  'warehouse_create',
  'warehouse_edit',
  'warehouse_delete',
  'chamber_operations',
  'bin_operations',
  'crate_operations',
  'storage_view',
  'storage_create',
  'storage_update',
  'storage_allocate',

  // Inward booking
  'inward_operations',
  'inward_admin',
  'inward_booking_view',
  'inward_booking_create',
  'inward_booking_edit',
  'inward_booking_delete',

  // Gate
  'gate_operations',
  'security_operations',
  'gate_entry_view',
  'gate_entry_create',
  'gate_entry_verify',

  // Weighment
  'weighbridge_operations',
  'weighment_view',
  'weighment_create',
  'weighment_verify',

  // Unloading
  'unloading_view',
  'unloading_create',
  'unloading_verify',

  // Inspection / grading
  'quality_operations',
  'inspection_view',
  'inspection_create',
  'inspection_approve',
  'inspection_reject',
  'grading_operations',
  'grading_view',
  'grading_create',
  'grading_update',
  'grading_verify',
  'quality_reject',
  'quality_hold',
  'quality_release',

  // Lots
  'lot_view',
  'lot_create',
  'lot_update',

  // Outward / dispatch
  'outward_view',
  'outward_create',
  'outward_edit',
  'outward_operations',
  'dispatch_view',
  'dispatch_create',
  'dispatch_edit',

  // Billing / finance
  'billing_operations',
  'billing_view',
  'billing_create',
  'billing_approve',
  'invoices_view',
  'invoices_create',
  'invoices_edit',
  'payments_view',
  'payments_process',
  'finance_operations',
  'cash_operations',
  'audit_operations',

  // Trading
  'purchase_operations',
  'sales_operations',

  // Employees / HR
  'employees_view',
  'employees_edit',
  'hr_operations',
  'attendance_operations',
  'attendance_view',
  'attendance_create',
  'attendance_edit',
  'attendance_settings',
  'leave_operations',
  'payroll_operations',

  // Settings
  'settings_view',
  'settings_edit',
  'financial_year_view',
  'financial_year_edit',

  // Notifications
  'notifications_view',
  'notifications_settings',

  // Reporting
  'reports_view',
  'reports_generate',
  'reports_export',
  'reports_management',
  'reports_inward',
  'reports_gate',
  'reports_quality',
  'reports_lots',
  'reports_storage',
  'reports_inventory',
  'reports_outward',
  'reports_growers',
  'reports_trading',
  'reports_finance',
  'reports_hr',

  // Operations / utilities
  'temperature_view',
  'temperature_edit',
  'temperature_configure',
  'temperature_device_manage',
  'temperature_alerts',
  'temperature_acknowledge',
  'temperature_export',
  'maintenance_view',
  'maintenance_edit',
  'services_view',
  'services_edit',
  'deployment_view',
  'deployment_edit',

  // Premium module permissions
  'crm_view',
  'crm_manage',
  'integrations_view',
  'integrations_manage',
  'bank_reconciliation_view',
  'bank_reconciliation_manage',
  'whatsapp_automation_view',
  'whatsapp_automation_manage',
  'form_settings_view',
  'form_settings_edit',

  // Dynamic workflow / on-demand modules
  'workflow_config_view',
  'workflow_config_edit',
  'workflow_combined_execute',
  'workflow_stage_override',
  'service_providers_view',
  'service_providers_manage',
  'service_provider_bills_manage',
  'service_provider_payments_manage',
  'internal_documents_view',
  'internal_documents_upload',
  'internal_documents_share',
  'internal_documents_manage',
  'addon_requests_view',
  'addon_requests_create',
  'custom_module_requests_create',
  'support_view',
  'support_create',
  'support_reply',
  'subscription_receipts_view',
  'subscription_receipts_download',
  'customization_view',
  'grower_360_receipt',
  'addon_quotations_view',
  'addon_quotations_accept',

  // Portal permissions retained from the existing CMS
  'customer_portal_access',
  'customer_inventory_view',
  'customer_orders_view',
  'customer_billing_view',
  'grower_portal_access',
  'grower_products_view',
  'grower_agreements_view',
  'grower_inventory_view',
  'sub_grower_portal_access',
  'sub_grower_products_view',
  'sub_grower_agreements_view',
  'transporter_portal_access',
  'transporter_dispatch_view',
  'transporter_delivery_view',
  ...ROLE_PERMISSION_CODES,
])));

export const CMS_PERMISSION_GROUPS = Object.freeze([
  {
    key: 'dashboard',
    label: 'Dashboard',
    permissions: ['dashboard_view'],
  },
  {
    key: 'products',
    label: 'Products & Categories',
    permissions: [
      'products_view', 'products_create',
      'products_edit', 'products_delete'
    ],
  },
  {
    key: 'growers',
    label: 'Growers & Agreements',
    permissions: [
      'customers_view', 'customers_create',
      'customers_edit', 'customers_delete',
      'agreements_view', 'agreements_create',
      'agreements_edit'
    ],
  },
  {
    key: 'inventory',
    label: 'Inventory',
    permissions: [
      'inventory_view', 'inventory_create',
      'inventory_edit', 'inventory_adjust',
      'crate_operations'
    ],
  },
  {
    key: 'warehouse',
    label: 'Warehouse & Storage',
    permissions: [
      'warehouse_view', 'warehouse_create',
      'warehouse_edit', 'warehouse_delete',
      'chamber_operations', 'bin_operations',
      'storage_view', 'storage_create',
      'storage_update', 'storage_allocate'
    ],
  },
  {
    key: 'inward',
    label: 'Inward Workflow',
    permissions: [
      'inward_operations', 'inward_admin',
      'inward_booking_view', 'inward_booking_create',
      'inward_booking_edit', 'inward_booking_delete',
      'gate_operations', 'security_operations',
      'gate_entry_view', 'gate_entry_create', 'gate_entry_verify',
      'weighbridge_operations',
      'weighment_view', 'weighment_create', 'weighment_verify',
      'unloading_view', 'unloading_create', 'unloading_verify',
      'quality_operations',
      'inspection_view', 'inspection_create',
      'inspection_approve', 'inspection_reject',
      'grading_operations',
      'grading_view', 'grading_create',
      'grading_update', 'grading_verify',
      'lot_view', 'lot_create', 'lot_update',
      'quality_reject', 'quality_hold', 'quality_release',
      'workflow_config_view', 'workflow_config_edit',
      'workflow_combined_execute', 'workflow_stage_override'
    ],
  },
  {
    key: 'outward',
    label: 'Outward & Dispatch',
    permissions: [
      'outward_view', 'outward_create',
      'outward_edit', 'outward_operations',
      'dispatch_view', 'dispatch_create', 'dispatch_edit'
    ],
  },
  {
    key: 'finance',
    label: 'Finance & Billing',
    permissions: [
      'billing_operations', 'billing_view',
      'billing_create', 'billing_approve',
      'invoices_view', 'invoices_create', 'invoices_edit',
      'payments_view', 'payments_process',
      'finance_operations', 'cash_operations', 'audit_operations'
    ],
  },
  {
    key: 'trading',
    label: 'Trading',
    permissions: ['purchase_operations', 'sales_operations'],
  },
  {
    key: 'hr',
    label: 'HR, Attendance & Payroll',
    permissions: [
      'employees_view', 'employees_edit',
      'hr_operations',
      'attendance_operations', 'attendance_view',
      'attendance_create', 'attendance_edit',
      'attendance_settings',
      'leave_operations', 'payroll_operations'
    ],
  },
  {
    key: 'reports',
    label: 'Reporting',
    permissions: [
      'reports_view', 'reports_generate', 'reports_export',
      'reports_management', 'reports_inward', 'reports_gate',
      'reports_quality', 'reports_lots', 'reports_storage',
      'reports_inventory', 'reports_outward', 'reports_growers',
      'reports_trading', 'reports_finance', 'reports_hr'
    ],
  },
  {
    key: 'notifications',
    label: 'Notifications',
    permissions: [
      'notifications_view', 'notifications_settings'
    ],
  },
  {
    key: 'settings',
    label: 'Settings & Financial Year',
    permissions: [
      'settings_view', 'settings_edit',
      'financial_year_view', 'financial_year_edit'
    ],
  },
  {
    key: 'premium_modules',
    label: 'Premium Modules',
    permissions: [
      'crm_view', 'crm_manage',
      'integrations_view', 'integrations_manage',
      'bank_reconciliation_view', 'bank_reconciliation_manage',
      'whatsapp_automation_view', 'whatsapp_automation_manage',
      'form_settings_view', 'form_settings_edit',
      'service_providers_view', 'service_providers_manage',
      'service_provider_bills_manage', 'service_provider_payments_manage',
      'internal_documents_view', 'internal_documents_upload',
      'internal_documents_share', 'internal_documents_manage',
      'addon_requests_view', 'addon_requests_create',
      'custom_module_requests_create', 'addon_quotations_view',
      'addon_quotations_accept'
    ],
  },
  {
    key: 'operations',
    label: 'Monitoring & Maintenance',
    permissions: [
      'temperature_view', 'temperature_edit',
      'temperature_configure', 'temperature_device_manage',
      'temperature_alerts', 'temperature_acknowledge',
      'temperature_export',
      'maintenance_view', 'maintenance_edit',
      'services_view', 'services_edit',
      'deployment_view', 'deployment_edit'
    ],
  },
  {
    key: 'portals',
    label: 'Portal Access',
    permissions: [
      'customer_portal_access',
      'customer_inventory_view',
      'customer_orders_view',
      'customer_billing_view',
      'grower_portal_access',
      'grower_products_view',
      'grower_agreements_view',
      'grower_inventory_view',
      'sub_grower_portal_access',
      'sub_grower_products_view',
      'sub_grower_agreements_view',
      'transporter_portal_access',
      'transporter_dispatch_view',
      'transporter_delivery_view'
    ],
  },
]);

export const REPORT_PERMISSION_BY_CATEGORY = Object.freeze({
  management: 'reports_management',
  inward: 'reports_inward',
  gate: 'reports_gate',
  quality: 'reports_quality',
  lots: 'reports_lots',
  storage: 'reports_storage',
  inventory: 'reports_inventory',
  outward: 'reports_outward',
  growers: 'reports_growers',
  trading: 'reports_trading',
  finance: 'reports_finance',
  hr: 'reports_hr',
});


/* --------------------------------------------------------------------------
   Legacy permission compatibility
   --------------------------------------------------------------------------
   Agreement permissions were added after the original Grower/Customer module
   permissions in some existing tenant roles.

   Keep the dedicated agreements_* permissions for new roles, but allow an old
   role that already had the equivalent customer/grower CRUD permission to keep
   the same business capability after the Agreement module was introduced.

   This is NOT a role-name bypass. It only derives an equivalent permission
   from another already-granted CRUD permission.
-------------------------------------------------------------------------- */
export const expandPermissionAliases = (permissions = []) => {
  const source = Array.isArray(permissions)
    ? permissions
    : [];

  const set = new Set(
    source
      .filter(
        (permission) =>
          typeof permission === 'string' &&
          permission.trim()
      )
      .map((permission) =>
        permission.trim().toLowerCase()
      )
  );

  const hasAny = (...keys) =>
    keys.some((key) => set.has(key));

  // Legacy Grower/Customer -> Agreement compatibility.
  if (hasAny('customers_view', 'growers_view')) {
    set.add('agreements_view');
  }

  if (hasAny('customers_create', 'growers_create')) {
    set.add('agreements_create');
  }

  if (hasAny('customers_edit', 'growers_edit')) {
    set.add('agreements_edit');
  }

  // Singular aliases used by a few older role seeds.
  if (set.has('agreement_view')) set.add('agreements_view');
  if (set.has('agreement_create')) set.add('agreements_create');
  if (set.has('agreement_edit')) set.add('agreements_edit');
  if (set.has('agreement_delete')) set.add('agreements_delete');

  // Legacy broad operational permissions are expanded only for backward
  // compatibility. New roles should use the detailed stage permissions from
  // the module-based Role editor.
  const addMany = (...keys) => keys.forEach((key) => set.add(key));
  if (set.has('gate_operations') || set.has('security_operations')) {
    addMany('gate_entry_view', 'gate_entry_create', 'gate_entry_verify');
  }
  if (set.has('weighbridge_operations')) {
    addMany('weighment_view', 'weighment_create', 'weighment_verify');
  }
  if (set.has('quality_operations')) {
    addMany('inspection_view', 'inspection_create', 'inspection_approve', 'inspection_reject');
  }
  if (set.has('grading_operations')) {
    addMany(
      'grading_view', 'grading_create', 'grading_update', 'grading_verify',
      'outward_grading_view', 'outward_grading_process', 'outward_grading_edit', 'outward_grading_verify'
    );
  }
  if (set.has('packing_process')) {
    addMany('outward_packing_view', 'outward_packing_process', 'inward_packing_view', 'inward_packing_process');
  }
  if (set.has('finance_operations')) {
    addMany('finance_view', 'inward_finance_view', 'outward_finance_view');
  }

  // Reporting permission compatibility. Older roles used finance_reports while
  // the consolidated report center uses reports_finance + reports_view.
  // Category/report actions also imply the ability to open the report center;
  // this keeps menu visibility, route guards and report-card filtering aligned
  // without granting access to unrelated report categories.
  if (set.has('finance_reports')) addMany('reports_finance', 'reports_view');
  if (set.has('reports_finance')) addMany('finance_reports', 'reports_view');
  if (set.has('reports_generate') || set.has('reports_export')) set.add('reports_view');
  if ([...set].some((key) => key.startsWith('reports_') && !['reports_generate','reports_export','reports_view'].includes(key))) {
    set.add('reports_view');
  }
  if (set.has('crate_operations')) {
    addMany(
      'crate_stock_view', 'crate_stock_add', 'crate_assign', 'crate_return',
      'crate_damage', 'crate_missing', 'crate_transfer', 'crate_adjust', 'crate_ledger_view'
    );
  }

  return Array.from(set);
};

export const hasAnyPermission = (
  permissions = [],
  requiredPermissions = []
) => {
  const current = expandPermissionAliases(permissions);
  const required = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : [requiredPermissions];

  if (current.includes('all')) return true;
  if (!required.filter(Boolean).length) return true;

  return required
    .filter(Boolean)
    .some((permission) => current.includes(permission));
};

export const hasAllPermissions = (
  permissions = [],
  requiredPermissions = []
) => {
  const current = expandPermissionAliases(permissions);
  const required = Array.isArray(requiredPermissions)
    ? requiredPermissions
    : [requiredPermissions];

  if (current.includes('all')) return true;

  return required
    .filter(Boolean)
    .every((permission) => current.includes(permission));
};

export const isAccessAllowed = (
  permissions = [],
  accessRule = null
) => {
  if (!accessRule) return true;
  if (accessRule.alwaysVisible === true) return true;

  const current = expandPermissionAliases(permissions);

  if (current.includes('all')) return true;

  const allOf = accessRule.allOf || [];
  const anyOf =
    accessRule.anyOf ||
    accessRule.permissions ||
    [];

  if (
    allOf.length &&
    !hasAllPermissions(current, allOf)
  ) {
    return false;
  }

  if (
    anyOf.length &&
    !hasAnyPermission(current, anyOf)
  ) {
    return false;
  }

  return true;
};

export const CMS_MENU = [
  {
    icon: '📊',
    label: 'Dashboard',
    path: '/company-dashboard',
    permissions: ['dashboard_view'],
  },
  {
    key: 'inventory',
    icon: '📦',
    label: 'Inventory',
    subItems: [
      {
        label: '📊 Dashboard',
        path: '/inventory',
        exact: true,
        permissions: ['inventory_view'],
      },
      {
        label: '🔄 Transfer',
        path: '/inventory/transfer',
        permissions: ['inventory_edit'],
      },
      {
        label: '⚖️ Adjustment',
        path: '/inventory/adjustment',
        permissions: ['inventory_adjust'],
      },
    ],
  },
  {
    key: 'inward',
    icon: '📥',
    label: 'Inward Management',
    subItems: [
      {
        label: '📋 Gate Pass Registration',
        path: '/inward',
        exact: true,
        permissions: ['inward_operations', 'inward_admin', 'inward_booking_view', 'inward_booking_create', 'inward_booking_edit'],
      },
      {
        label: '📊 Inward Process Dashboard',
        path: '/inward/dashboard',
        permissions: [
          'inward_operations', 'inward_admin', 'inward_booking_view',
          'gate_entry_view', 'weighment_view', 'unloading_view',
          'inspection_view', 'lot_view', 'storage_view'
        ],
      },
      {
        label: '🧩 Combined Workflow Workbench',
        path: '/inward/workbench',
        permissions: [
          'inward_operations', 'inward_admin', 'inward_booking_view',
          'gate_entry_view', 'weighment_view', 'unloading_view',
          'inspection_view', 'lot_view', 'storage_view'
        ],
      },
      {
        label: '🚪 Gate Pass',
        path: '/inward/gate-entry',
        permissions: ['gate_entry_view', 'gate_entry_create', 'gate_entry_edit', 'gate_entry_verify', 'gate_entry_override', 'gate_entry_revert', 'gate_entry_print'],
      },
      {
        label: '⚖️ Weighment · Gross + Tare/Net',
        path: '/inward/weighment',
        permissions: ['weighment_view', 'weighment_create', 'weighment_edit', 'weighment_verify', 'weighment_override', 'weighment_revert', 'weighment_print'],
      },
      {
        label: '📦 Unloading + Inspection',
        path: '/inward/unloading',
        permissions: [
          'unloading_view', 'unloading_create', 'unloading_edit', 'unloading_verify',
          'unloading_override', 'unloading_revert', 'unloading_print',
          'inspection_view', 'inspection_create', 'inspection_edit', 'inspection_approve',
          'inspection_reject', 'inspection_override', 'inspection_revert', 'inspection_print'
        ],
      },
      {
        label: '🏷️ Inward Grading',
        path: '/inward/grading',
        permissions: ['grading_view', 'grading_create', 'grading_update', 'grading_verify', 'grading_override', 'grading_revert', 'grading_print'],
      },
      {
        label: '🧾 Inward Finance',
        path: '/inward/finance',
        permissions: ['inward_finance_view', 'inward_finance_process', 'inward_finance_edit', 'inward_finance_approve', 'inward_finance_credit', 'inward_finance_override'],
      },
      {
        label: '📦 Inward Packing',
        path: '/inward/packing',
        permissions: ['inward_packing_view', 'inward_packing_process', 'inward_packing_edit', 'inward_packing_override', 'inward_packing_revert', 'inward_packing_print'],
      },
      {
        label: '🏷️ Lot Creation',
        path: '/inward/lot-creation',
        permissions: ['lot_view', 'lot_create', 'lot_update', 'lot_delete', 'lot_override', 'lot_revert', 'lot_print'],
      },
      {
        label: '📍 Storage Allocation',
        path: '/inward/storage',
        permissions: ['storage_view', 'storage_create', 'storage_update', 'storage_allocate', 'storage_override', 'storage_revert', 'storage_print'],
      },
    ],
  },
  {
    key: 'outward',
    icon: '📤',
    label: 'Outward Management',
    subItems: [
      {
        label: '📤 Outward',
        path: '/outward',
        exact: true,
        permissions: [
          'outward_view', 'outward_operations', 'outward_request_view',
          'outward_approval_view', 'outward_retrieval_view', 'outward_grading_view',
          'outward_packing_view', 'outward_finance_view', 'outward_loading_view', 'dispatch_view'
        ],
      },
      {
        label: '➕ New Outward',
        path: '/outward/new',
        permissions: ['outward_create'],
      },
    ],
  },
  {
    key: 'storage',
    icon: '🏪',
    label: 'Storage Management',
    subItems: [
      {
        label: '📊 Dashboard',
        path: '/storage/dashboard',
        permissions: ['storage_view'],
      },
      {
        label: '📦 Bins',
        path: '/storage/bins',
        permissions: ['storage_view', 'inventory_view', 'bin_operations'],
      },
      {
        label: '🧺 Crates',
        path: '/storage/crates',
        permissions: ['crate_stock_view', 'crate_assign', 'crate_return', 'crate_damage', 'crate_missing', 'crate_transfer', 'crate_adjust', 'crate_ledger_view', 'crate_operations'],
      },
    ],
  },
  {
    key: 'growers',
    icon: '🌾',
    label: 'Growers',
    subItems: [
      {
        label: '🌾 All Growers',
        path: '/growers',
        exact: true,
        permissions: ['customers_view'],
      },
      {
        label: '➕ Add Grower',
        path: '/growers/add',
        permissions: ['customers_create'],
      },
      {
        label: '🌱 Sub Growers',
        path: '/growers?type=sub_grower',
        permissions: ['customers_view'],
      },
    ],
  },
  {
    key: 'agreements',
    icon: '📄',
    label: 'Agreements',
    subItems: [
      {
        label: '📄 All Agreements',
        path: '/agreements',
        exact: true,
        permissions: ['agreements_view'],
      },
      {
        label: '➕ New Agreement',
        path: '/agreements/create',
        permissions: ['agreements_create', 'customers_create', 'growers_create'],
      },
    ],
  },
  {
    key: 'warehouse',
    icon: '🏭',
    label: 'Warehouse',
    subItems: [
      {
        label: '🏭 Warehouses',
        path: '/warehouses',
        permissions: ['warehouse_view'],
      },
      {
        label: '❄️ Chambers',
        path: '/chambers',
        permissions: ['warehouse_view', 'chamber_operations'],
      },
    ],
  },




// Suggested menu addition inside the COMPANY/TENANT menu only:

{
  key: 'notifications',
  label: 'Notifications',
  icon: '🔔',
  subItems: [
    {
      key: 'notification-center',
      label: 'Notification Center',
      path: '/notifications',
      permissions: ['notifications_view']
    },
    {
      key: 'notification-settings',
      label: 'Notification Settings',
      path: '/notification-settings',
      permissions: ['notifications_settings']
    }
  ]
},


  {
    key: 'trading',
    icon: '🤝',
    label: 'Trading',
    subItems: [
      {
        label: '📊 Trading Dashboard',
        path: '/trading',
        exact: true,
        permissions: ['purchase_operations', 'sales_operations'],
      },
      {
        label: '➕ New Trade',
        path: '/trading/create',
        permissions: ['purchase_operations', 'sales_operations'],
      },
    ],
  },
  {
    icon: '🍎',
    label: 'Products',
    path: '/products',
    permissions: ['products_view', 'products_create', 'products_edit', 'products_delete'],
  },
  {
    icon: '📋',
    label: 'Categories',
    path: '/categories',
    permissions: ['products_view', 'products_create', 'products_edit', 'products_delete'],
  },
  {
    key: 'finance',
    icon: '💰',
    label: 'Finance Management',
    subItems: [
      {
        label: '📊 Dashboard',
        path: '/finance',
        exact: true,
        permissions: [
          'finance_operations',
          'finance_view',
          'invoices_view',
          'payments_view',
          'billing_view',
        ],
      },
      {
        label: '🧾 Invoices & Billing',
        path: '/finance/invoices',
        permissions: ['invoices_view', 'billing_view'],
      },
      {
        label: '📄 Receipts',
        path: '/finance/receipts',
        permissions: ['billing_view', 'payments_view'],
      },
      {
        label: '💳 Payments & Collections',
        path: '/finance/payments',
        permissions: ['payments_view'],
      },
      {
        label: '🌾 Grower Ledger',
        path: '/finance/ledger',
        permissions: ['finance_operations', 'finance_view', 'billing_view', 'growers_view'],
      },
      {
        label: '📌 Receivables / Outstanding',
        path: '/finance/receivables',
        permissions: ['finance_operations', 'payments_view'],
      },
      {
        label: '💸 Expenses',
        path: '/finance/expenses',
        permissions: ['finance_operations', 'cash_operations'],
      },
      {
        label: '🏦 Cash / Bank Accounts',
        path: '/finance/accounts',
        permissions: ['finance_operations', 'cash_operations'],
      },
      {
        label: '👨‍💼 Employee Payroll',
        path: '/finance/payroll',
        permissions: ['payroll_operations'],
      },
    ],
  },
  {
    key: 'employees',
    icon: '👨‍💼',
    label: 'Employees',
    subItems: [
      {
        label: '👥 All Employees',
        path: '/employees',
        exact: true,
        permissions: ['employees_view'],
      },
      {
        label: '📊 Statistics',
        path: '/employees/stats',
        permissions: ['employees_view', 'reports_hr'],
      },
    ],
  },
  {
    key: 'attendance',
    icon: '📋',
    label: 'Attendance',
    subItems: [
      {
        label: '📊 Manage Attendance',
        path: '/attendance',
        exact: true,
        permissions: ['attendance_operations', 'attendance_view', 'hr_operations'],
      },
      {
        label: '📸 Selfie Attendance Report',
        path: '/attendance/selfie-report',
        permissions: ['attendance_view', 'reports_hr', 'hr_operations'],
      },
    ],
  },
  {
    key: 'payroll',
    icon: '💰',
    label: 'Payroll',
    subItems: [
      {
        label: '📊 Manage Payroll',
        path: '/payroll',
        exact: true,
        permissions: ['payroll_operations'],
      },
    ],
  },
  {
    key: 'reporting',
    icon: '📊',
    label: 'Reporting',
    subItems: [
      {
        label: '📊 Reports Command Center',
        path: '/company/reports',
        exact: true,
        permissions: ['reports_view', 'reports_generate', 'reports_management', 'reports_inward', 'reports_gate', 'reports_quality', 'reports_lots', 'reports_storage', 'reports_inventory', 'reports_outward', 'reports_growers', 'reports_trading', 'reports_finance', 'reports_hr'],
      },
      {
        label: '📥 Inward Reports',
        path: '/company/reports/inward/inward-register',
        permissions: ['reports_inward'],
      },
      {
        label: '🏷 Lot Reports',
        path: '/company/reports/lots/lot-register',
        permissions: ['reports_lots'],
      },
      {
        label: '🏭 Storage Reports',
        path: '/company/reports/storage/warehouse-capacity',
        permissions: ['reports_storage'],
      },
      {
        label: '📤 Outward Reports',
        path: '/company/reports/outward/outward-register',
        permissions: ['reports_outward'],
      },
      {
        label: '💰 Finance Reports',
        path: '/company/reports/finance',
        permissions: ['reports_finance'],
      },
      {
        label: '👨‍💼 HR Reports',
        path: '/company/reports/hr/employee-master',
        permissions: ['reports_hr'],
      },
    ],
  },
  {
    key: 'operations',
    icon: '🛠️',
    label: 'Operations & Monitoring',
    subItems: [
      {
        label: '🌡️ Temperature Dashboard',
        path: '/temperature',
        exact: true,
        permissions: ['temperature_view'],
      },
      {
        label: '📡 Sensor Configuration',
        path: '/temperature/sensors',
        permissions: [
          'temperature_configure',
          'temperature_edit',
          'temperature_device_manage'
        ],
      },
      {
        label: '🚨 Temperature Alerts',
        path: '/temperature/alerts',
        allOf: ['temperature_view'],
        anyOf: [
          'temperature_alerts',
          'temperature_acknowledge',
          'temperature_edit'
        ],
      },
    ],
  },
  {
    key: 'settings',
    icon: '⚙️',
    label: 'Settings',
    subItems: [
      {
        label: '🏢 Company Settings',
        path: '/company-settings',
        permissions: ['settings_view'],
      },
      {
        label: '📅 Financial Year',
        path: '/financial-year',
        permissions: ['financial_year_view'],
      },
      {
        label: '🧾 Audit Trail',
        path: '/audit-trail',
        permissions: ['audit_operations', 'workflow_audit_view', 'offline_server_audit'],
      },
    ],
  },
];

// Rules are intentionally ordered most-specific first.
export const ROUTE_ACCESS = [
  { test: /^\/company-dashboard(?:\/|$)/, permissions: ['dashboard_view'] },
  { test: /^\/premium-addons(?:\/|$)/, permissions: [] },
  { test: /^\/form-field-settings(?:\/|$)/, permissions: ['form_settings_view', 'form_settings_edit', 'settings_edit'] },
  { test: /^\/label-designer(?:\/|$)/, permissions: ['form_settings_view', 'form_settings_edit', 'settings_edit'] },
  { test: /^\/integrations(?:\/|$)/, permissions: ['integrations_view', 'integrations_manage', 'settings_edit'] },
  { test: /^\/crm(?:\/|$)/, permissions: ['crm_view', 'crm_manage'] },
  { test: /^\/finance\/(?:reconciliation|cheques)(?:\/|$)/, permissions: ['bank_reconciliation_view', 'bank_reconciliation_manage', 'finance_operations'] },
  { test: /^\/whatsapp-automation(?:\/|$)/, permissions: ['whatsapp_automation_view', 'whatsapp_automation_manage', 'notifications_settings'] },
  { test: /^\/service-providers(?:\/|$)/, permissions: ['service_providers_view', 'service_providers_manage'] },
  { test: /^\/internal-documents(?:\/|$)/, permissions: ['internal_documents_view', 'internal_documents_upload', 'internal_documents_share'] },
  { test: /^\/inward\/workbench(?:\/|$)/, permissions: ['workflow_combined_execute', 'inward_operations', 'inward_admin'] },

  { test: /^\/company\/reports\/management(?:\/|$)/, permissions: ['reports_management'] },
  { test: /^\/company\/reports\/inward(?:\/|$)/, permissions: ['reports_inward'] },
  { test: /^\/company\/reports\/gate(?:\/|$)/, permissions: ['reports_gate'] },
  { test: /^\/company\/reports\/quality(?:\/|$)/, permissions: ['reports_quality'] },
  { test: /^\/company\/reports\/lots(?:\/|$)/, permissions: ['reports_lots'] },
  { test: /^\/company\/reports\/storage(?:\/|$)/, permissions: ['reports_storage'] },
  { test: /^\/company\/reports\/inventory(?:\/|$)/, permissions: ['reports_inventory'] },
  { test: /^\/company\/reports\/outward(?:\/|$)/, permissions: ['reports_outward'] },
  { test: /^\/company\/reports\/growers(?:\/|$)/, permissions: ['reports_growers'] },
  { test: /^\/company\/reports\/trading(?:\/|$)/, permissions: ['reports_trading'] },
  { test: /^\/company\/reports\/finance(?:\/|$)/, permissions: ['reports_finance'] },
  { test: /^\/company\/reports\/hr(?:\/|$)/, permissions: ['reports_hr'] },
  { test: /^\/company\/reports(?:\/|$)/, permissions: ['reports_view', 'reports_generate', 'reports_management', 'reports_inward', 'reports_gate', 'reports_quality', 'reports_lots', 'reports_storage', 'reports_inventory', 'reports_outward', 'reports_growers', 'reports_trading', 'reports_finance', 'reports_hr'] },

  {
    test: /^\/inward\/(?:public-request-management|public-requests)(?:\/|$)/,
    permissions: [
      'inward_admin',
      'inward_operations',
      'inward_booking_view',
      'inward_booking_create',
      'inward_booking_edit'
    ]
  },
  { test: /^\/inward\/gate-entry(?:\/|$)/, permissions: ['gate_entry_view', 'gate_entry_create', 'gate_entry_edit', 'gate_entry_verify', 'gate_entry_override', 'gate_entry_revert', 'gate_entry_print'] },
  { test: /^\/inward\/weighment(?:\/|$)/, permissions: ['weighment_view', 'weighment_create', 'weighment_edit', 'weighment_verify', 'weighment_override', 'weighment_revert', 'weighment_print'] },
  { test: /^\/inward\/unloading(?:\/|$)/, permissions: ['unloading_view', 'unloading_create', 'unloading_edit', 'unloading_verify', 'unloading_override', 'unloading_revert', 'inspection_view', 'inspection_create', 'inspection_edit', 'inspection_approve', 'inspection_reject', 'inspection_override', 'inspection_revert'] },
  { test: /^\/inward\/grading(?:\/|$)/, permissions: ['grading_view', 'grading_create', 'grading_update', 'grading_verify', 'grading_override', 'grading_revert', 'grading_print'] },
  { test: /^\/inward\/finance(?:\/|$)/, permissions: ['inward_finance_view', 'inward_finance_process', 'inward_finance_edit', 'inward_finance_approve', 'inward_finance_credit', 'inward_finance_override', 'inward_finance_print'] },
  { test: /^\/inward\/packing(?:\/|$)/, permissions: ['inward_packing_view', 'inward_packing_process', 'inward_packing_edit', 'inward_packing_override', 'inward_packing_revert', 'inward_packing_print'] },
  { test: /^\/inward\/lot-creation(?:\/|$)/, permissions: ['lot_view', 'lot_create', 'lot_update', 'lot_delete', 'lot_override', 'lot_revert', 'lot_print'] },
  { test: /^\/inward\/storage(?:\/|$)/, permissions: ['storage_view', 'storage_create', 'storage_update', 'storage_allocate', 'storage_override', 'storage_revert', 'storage_print'] },
  { test: /^\/inward\/dashboard(?:\/|$)/, permissions: ['inward_operations', 'inward_admin', 'inward_booking_view', 'gate_operations', 'gate_entry_view', 'weighbridge_operations', 'weighment_view', 'unloading_view', 'quality_operations', 'inspection_view', 'lot_view', 'storage_view'] },
  { test: /^\/inward(?:\/|$)/, permissions: ['inward_operations', 'inward_admin', 'inward_booking_view', 'inward_booking_create', 'inward_booking_edit', 'gate_operations', 'gate_entry_view', 'weighbridge_operations', 'weighment_view', 'unloading_view', 'quality_operations', 'inspection_view', 'lot_view', 'storage_view'] },

  { test: /^\/outward\/new(?:\/|$)/, permissions: ['outward_create'] },
  { test: /^\/outward\/(?:approval|approve)(?:\/|$)/, permissions: ['outward_approval_view', 'outward_approve', 'outward_reject'] },
  { test: /^\/outward\/retrieval(?:\/|$)/, permissions: ['outward_retrieval_view', 'outward_retrieval_process', 'outward_retrieval_edit'] },
  { test: /^\/outward\/grading(?:\/|$)/, permissions: ['outward_grading_view', 'outward_grading_process', 'outward_grading_edit', 'outward_grading_verify', 'grading_view', 'grading_operations'] },
  { test: /^\/outward\/packing(?:\/|$)/, permissions: ['outward_packing_view', 'outward_packing_process', 'outward_packing_edit', 'packing_process'] },
  { test: /^\/outward\/(?:finance|billing|payment)(?:\/|$)/, permissions: ['outward_finance_view', 'outward_finance_process', 'outward_finance_edit', 'finance_view', 'finance_operations'] },
  { test: /^\/outward\/(?:loading|dispatch|gatepass)(?:\/|$)/, permissions: ['outward_loading_view', 'outward_loading_process', 'outward_loading_edit', 'dispatch_view', 'dispatch_create', 'dispatch_edit'] },
  { test: /^\/outward(?:\/|$)/, permissions: ['outward_view', 'outward_operations', 'outward_request_view', 'outward_create', 'outward_approval_view', 'outward_retrieval_view', 'outward_grading_view', 'outward_packing_view', 'outward_finance_view', 'outward_loading_view', 'dispatch_view'] },

  { test: /^\/storage\/bins\/bulk-create(?:\/|$)/, permissions: ['bin_operations', 'inventory_create', 'storage_create'] },
  { test: /^\/storage\/bins(?:\/|$)/, permissions: ['storage_view', 'inventory_view', 'bin_operations'] },
  { test: /^\/storage\/crates(?:\/|$)/, permissions: ['crate_stock_view', 'crate_assign', 'crate_return', 'crate_damage', 'crate_missing', 'crate_transfer', 'crate_adjust', 'crate_ledger_view', 'crate_operations'] },
  { test: /^\/storage(?:\/|$)/, permissions: ['storage_view'] },

  { test: /^\/warehouses\/[^/]+\/chambers\/create(?:\/|$)/, permissions: ['warehouse_edit', 'warehouse_create', 'chamber_operations'] },
  { test: /^\/warehouses\/[^/]+\/chambers(?:\/|$)/, permissions: ['warehouse_view', 'chamber_operations'] },
  { test: /^\/warehouses(?:\/|$)/, permissions: ['warehouse_view', 'warehouse_create', 'warehouse_edit', 'warehouse_delete', 'chamber_operations'] },
  { test: /^\/chambers(?:\/|$)/, permissions: ['warehouse_view', 'warehouse_create', 'warehouse_edit', 'chamber_operations'] },

  { test: /^\/inventory\/transfer(?:\/|$)/, permissions: ['inventory_edit'] },
  { test: /^\/inventory\/adjustment(?:\/|$)/, permissions: ['inventory_adjust'] },
  { test: /^\/inventory(?:\/|$)/, permissions: ['inventory_view', 'inventory_create', 'inventory_edit', 'inventory_adjust', 'crate_operations'] },

  { test: /^\/growers\/add(?:\/|$)/, permissions: ['customers_create', 'customers_edit'] },
  { test: /^\/growers\/[^/]+\/edit(?:\/|$)/, permissions: ['customers_edit'] },
  { test: /^\/growers(?:\/|$)/, permissions: ['customers_view', 'customers_create', 'customers_edit', 'customers_delete'] },

  { test: /^\/agreements\/create(?:\/|$)/, permissions: ['agreements_create', 'customers_create', 'growers_create'] },
  { test: /^\/agreements\/[^/]+\/edit(?:\/|$)/, permissions: ['agreements_edit', 'customers_edit', 'growers_edit'] },
  { test: /^\/agreements(?:\/|$)/, permissions: ['agreements_view', 'agreements_create', 'agreements_edit', 'customers_view', 'customers_create', 'customers_edit', 'growers_view', 'growers_create', 'growers_edit'] },

  { test: /^\/products\/add(?:\/|$)/, permissions: ['products_create'] },
  { test: /^\/products\/[^/]+\/edit(?:\/|$)/, permissions: ['products_edit'] },
  { test: /^\/products(?:\/|$)/, permissions: ['products_view', 'products_create', 'products_edit', 'products_delete'] },
  { test: /^\/categories(?:\/|$)/, permissions: ['products_view', 'products_create', 'products_edit', 'products_delete'] },

  { test: /^\/trading\/create(?:\/|$)/, permissions: ['purchase_operations', 'sales_operations'] },
  { test: /^\/trading\/[^/]+\/edit(?:\/|$)/, permissions: ['purchase_operations', 'sales_operations'] },
  { test: /^\/trading(?:\/|$)/, permissions: ['purchase_operations', 'sales_operations'] },

  { test: /^\/invoices\/create(?:\/|$)/, permissions: ['invoices_create'] },
  { test: /^\/invoices\/[^/]+\/edit(?:\/|$)/, permissions: ['invoices_edit'] },
  { test: /^\/invoices(?:\/|$)/, permissions: ['invoices_view'] },

  { test: /^\/finance\/invoices(?:\/|$)/, permissions: ['invoices_view', 'billing_view'] },
  { test: /^\/finance\/receipts(?:\/|$)/, permissions: ['billing_view', 'payments_view'] },
  { test: /^\/finance\/payments(?:\/|$)/, permissions: ['payments_view'] },
  { test: /^\/finance\/ledger(?:\/|$)/, permissions: ['finance_operations', 'finance_view', 'billing_view', 'growers_view'] },
  { test: /^\/finance\/(?:receivables|outstanding)(?:\/|$)/, permissions: ['finance_operations', 'payments_view'] },
  { test: /^\/finance\/expenses(?:\/|$)/, permissions: ['finance_operations', 'cash_operations'] },
  { test: /^\/finance\/accounts(?:\/|$)/, permissions: ['finance_operations', 'cash_operations'] },
  { test: /^\/finance\/reports(?:\/|$)/, permissions: ['reports_finance', 'finance_reports', 'finance_view', 'finance_operations'] },
  { test: /^\/finance\/payroll(?:\/|$)/, permissions: ['payroll_operations'] },
  { test: /^\/finance(?:\/|$)/, permissions: ['finance_operations', 'finance_view', 'cash_operations', 'billing_operations', 'billing_view', 'billing_create', 'billing_approve', 'invoices_view', 'invoices_create', 'invoices_edit', 'payments_view', 'payments_process', 'reports_finance'] },

  { test: /^\/employees\/create(?:\/|$)/, permissions: ['employees_create', 'employees_manage'] },
  { test: /^\/employees\/stats(?:\/|$)/, permissions: ['employees_view', 'reports_hr', 'reports_view'] },
  { test: /^\/employees\/[^/]+\/edit(?:\/|$)/, permissions: ['employees_edit', 'employees_manage'] },
  { test: /^\/employees\/unloading-work(?:\/|$)/, permissions: ['payroll_operations', 'hr_operations', 'finance_operations', 'finance_view', 'inward_admin'] },
  { test: /^\/employees\/[^/]+\/payroll(?:\/|$)/, permissions: ['payroll_operations'] },
  { test: /^\/employees\/payroll(?:\/|$)/, permissions: ['payroll_operations'] },
  { test: /^\/employees(?:\/|$)/, permissions: ['employees_view'] },

  { test: /^\/attendance\/reports(?:\/|$)/, permissions: ['reports_hr', 'reports_view', 'attendance_view'] },
  { test: /^\/attendance\/selfie-report(?:\/|$)/, permissions: ['attendance_view', 'reports_hr', 'hr_operations'] },
  { test: /^\/attendance\/selfie(?:\/|$)/, permissions: ['attendance_operations', 'attendance_create', 'hr_operations'] },
  { test: /^\/attendance\/(?:mark|bulk)(?:\/|$)/, permissions: ['attendance_operations', 'attendance_create', 'attendance_edit', 'hr_operations'] },
  { test: /^\/attendance(?:\/|$)/, permissions: ['attendance_operations', 'attendance_view', 'hr_operations'] },

  { test: /^\/payroll\/reports(?:\/|$)/, permissions: ['reports_hr', 'payroll_operations'] },
  { test: /^\/payroll\/slips(?:\/|$)/, permissions: ['payroll_operations', 'reports_hr'] },
  { test: /^\/payroll(?:\/|$)/, permissions: ['payroll_operations'] },

  { test: /^\/notification-settings(?:\/|$)/, permissions: ['notifications_settings'] },
  { test: /^\/notifications(?:\/|$)/, permissions: ['notifications_view'] },

  { test: /^\/(?:branches|branch-management)(?:\/|$)/, permissions: ['branches_view','branches_manage','branches_modules_manage','branches_reports'] },
  { test: /^\/audit-trail(?:\/|$)/, permissions: ['audit_operations', 'workflow_audit_view', 'offline_server_audit'] },
  { test: /^\/company-settings(?:\/|$)/, permissions: ['settings_view', 'branding_view', 'branding_edit', 'offline_server_view', 'offline_server_configure', 'offline_server_sync'] },
  { test: /^\/financial-year(?:\/|$)/, permissions: ['financial_year_view'] },

  {
    test: /^\/temperature\/sensors(?:\/|$)/,
    anyOf: [
      'temperature_configure',
      'temperature_edit',
      'temperature_device_manage'
    ]
  },
  {
    test: /^\/temperature\/alerts(?:\/|$)/,
    allOf: ['temperature_view'],
    anyOf: [
      'temperature_alerts',
      'temperature_acknowledge',
      'temperature_edit'
    ]
  },
  { test: /^\/temperature(?:\/|$)/, permissions: ['temperature_view'] },
  { test: /^\/maintenance(?:\/|$)/, permissions: ['maintenance_view'] },
  { test: /^\/services(?:\/|$)/, permissions: ['services_view'] },
  { test: /^\/deployment(?:\/|$)/, permissions: ['deployment_view'] },
];

export const getRouteAccess = (pathname = '') =>
  ROUTE_ACCESS.find((rule) => rule.test.test(pathname)) || null;